<template>
  <CRow>
    <CCol col="6">
      <CCard>
        <loader v-show="loading"/>
        <CCardHeader> <CIcon name="cil-grid" />Add Slider (664 x 451)
        </CCardHeader>
        <CCardBody>
          <div class="form-group">
						<img :src="data.url" style="width: 100%"/>
					</div>
          <div class="form-group">
						<file-upload @success="successUpload" @error="errorUpload" :config="config"/>
            <message-container :data="errors.url" />
          </div>
          <div class="form-inline row">
						<div class="col-md-3">
							<label>Urutan</label>
						</div>
						<div class="col-md-9">
							<input type="number" class="form-control" v-model="data.order">
						</div>
            <message-container :data="errors.order" />
          </div>
        </CCardBody>
        <CCardFooter>
          <btn-save-update :data="data" @back="doBack" @save="doSave" @update="doUpdate"/>
        </CCardFooter>
      </CCard>
    </CCol>
  </CRow>
</template>
<script>
import { authToken, HTTPAUTH } from "../../lib/httplib";
import BtnSaveUpdate from "../../components/BtnSaveUpdate";
import MessageContainer from "../../components/MessageContainer";
import Loader from '../../components/Loader.vue';
import FileUpload from '../../components/FileUpload.vue';
import { showErrorMessage } from '../../lib/helpers';
export default {
  components: {
    BtnSaveUpdate,
    MessageContainer,
    Loader,
    FileUpload,
  },
  data() {
    return {
      loading: false,
      data: {
				url: "",
        domain: "Admin",
        raw_input: "Register by Admin"
      },
      errors: [],
      reset: false,
      config: {
        url: process.env.VUE_APP_API_HOST + '/api/v1/file/upload',
        headers: {
					"authorization": "Bearer " + authToken(),
          'Content-Type': 'multipart/form-data',
				}
      }
    };
  },
  created() {
    const params = this.$route.params
    if (params && params.id) {
      this.get(params.id)
    }
  },
  methods: {
    get(id) {
      HTTPAUTH.get("/api/v1/admin/slider/" + id).then(resp => {
        this.data = resp.data.data;
      })
    },
    doBack() {
      this.$router.push({path: "/slider"})
    },
    doSave() {
			HTTPAUTH.post("/api/v1/admin/slider", this.data).then(res => {
				this.$router.push({path: "/slider/" + res.data.data.id}).catch(()=>{});
				this.$toasted.success("Berhasil upload data").goAway();
			}).catch(eres => {
				showErrorMessage(eres)
			})
    },
    doUpdate() {
			HTTPAUTH.put(`/api/v1/admin/slider/${this.data.id}`, this.data).then(() => {
				this.$toasted.success("Berhasil ubah data").goAway();
			}).catch(eres => {
				showErrorMessage(eres)
			})
    },
		successUpload(img) {
			this.data.url = img.data.url;
		},
		errorUpload(img) {
			this.$toasted.error("Error upload file").goAway();
			console.log(img)
		}
  },
  filters: {
  }
};
</script>